
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4">
  <path
    d="M3.38597 3.45854L0.526199 0.653922C0.460345 0.589292 0.526199 0.5 0.639614 0.5L6.36039 0.5C6.4738 0.5 6.53966 0.589292 6.4738 0.653922L3.61281 3.45854C3.55793 3.51382 3.44207 3.51382 3.38597 3.45854Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'CaretBottom',
    }) as DefineComponent
    </script>
    